// extracted by mini-css-extract-plugin
module.exports = {"RelatedItem":"RelatedItem_RelatedItem__1Y6y-","image":"RelatedItem_image__3uwy0"};